import type { Booking, ClientGallery, Package, Review, StudioSettings } from '../types';

export const demoPackages: Package[] = [
  {
    id: 'mini',
    name: 'Mini Pawtrait',
    namePl: 'Mini Pawtrait',
    description: 'A focused portrait session for one dog and one simple setup.',
    descriptionPl: 'Krótka, kameralna sesja portretowa dla jednego psa i prostego planu.',
    duration: '30 min',
    durationPl: '30 min',
    includedPhotos: 5,
    price: 390,
    extraPhotoPrice: 90
  },
  {
    id: 'standard',
    name: 'Standard Pawtrait',
    namePl: 'Standard Pawtrait',
    description: 'Our most popular session with time for variety, movement and portraits.',
    descriptionPl: 'Najczęściej wybierana sesja z czasem na różnorodne kadry, ruch i portrety.',
    duration: '60 min',
    durationPl: '60 min',
    includedPhotos: 10,
    price: 690,
    extraPhotoPrice: 90,
    highlighted: true
  },
  {
    id: 'premium',
    name: 'Premium Pawtrait',
    namePl: 'Premium Pawtrait',
    description: 'A relaxed extended session with multiple looks and a generous final set.',
    descriptionPl: 'Dłuższa, spokojna sesja z kilkoma stylami i większym zestawem finalnych zdjęć.',
    duration: '90 min',
    durationPl: '90 min',
    includedPhotos: 20,
    price: 1090,
    extraPhotoPrice: 80
  }
];

const demoPhotos = [
  ['DSC_1834.NEF', 'https://images.unsplash.com/photo-1552053831-71594a27632d?auto=format&fit=crop&w=1800&q=82'],
  ['DSC_1841.NEF', 'https://images.unsplash.com/photo-1543466835-00a7907e9de1?auto=format&fit=crop&w=1800&q=82'],
  ['DSC_1857.NEF', 'https://images.unsplash.com/photo-1537151608828-ea2b11777ee8?auto=format&fit=crop&w=1800&q=82'],
  ['DSC_1888.NEF', 'https://images.unsplash.com/photo-1517849845537-4d257902454a?auto=format&fit=crop&w=1800&q=82'],
  ['DSC_1902.NEF', 'https://images.unsplash.com/photo-1507146426996-ef05306b995a?auto=format&fit=crop&w=1800&q=82'],
  ['DSC_1911.NEF', 'https://images.unsplash.com/photo-1558788353-f76d92427f16?auto=format&fit=crop&w=1800&q=82'],
  ['DSC_1930.NEF', 'https://images.unsplash.com/photo-1551717743-49959800b1f6?auto=format&fit=crop&w=1800&q=82'],
  ['DSC_1945.NEF', 'https://images.unsplash.com/photo-1561037404-61cd46aa615b?auto=format&fit=crop&w=1800&q=82'],
  ['DSC_1970.NEF', 'https://images.unsplash.com/photo-1530281700549-e82e7bf110d6?auto=format&fit=crop&w=1800&q=82'],
  ['DSC_1981.NEF', 'https://images.unsplash.com/photo-1517423440428-a5a00ad493e8?auto=format&fit=crop&w=1800&q=82'],
  ['DSC_2010.NEF', 'https://images.unsplash.com/photo-1477884213360-7e9d7dcc1e48?auto=format&fit=crop&w=1800&q=82'],
  ['DSC_2027.NEF', 'https://images.unsplash.com/photo-1505628346881-b72b27e84530?auto=format&fit=crop&w=1800&q=82']
];

export const demoGalleries: ClientGallery[] = [
  {
    id: 'g1',
    galleryId: 'PAW-7K29D',
    pin: '2468',
    clientName: 'Anna Kowalska',
    email: 'anna@example.com',
    phone: '+48 600 000 000',
    dogName: 'Luna',
    sessionName: 'Autumn Portrait Session',
    sessionDate: '2026-09-05',
    packageId: 'standard',
    includedPhotos: 10,
    price: 690,
    extraPhotoPrice: 90,
    selectionDeadline: '2026-09-20',
    expiryDate: '2026-10-20',
    status: 'selection_open',
    paymentStatus: 'pending',
    selectionLocked: false,
    notes: 'Client prefers natural expressions and outdoor portraits.',
    archived: false,
    photos: demoPhotos.map(([filename, previewUrl], index) => ({
      id: `p${index + 1}`,
      filename,
      previewUrl,
      selected: index < 3,
      sortOrder: index
    }))
  },
  {
    id: 'g2',
    galleryId: 'PAW-A83KF',
    clientName: 'Michael Reed',
    email: 'michael@example.com',
    dogName: 'Baxter',
    sessionName: 'Studio Portraits',
    sessionDate: '2026-08-29',
    packageId: 'mini',
    includedPhotos: 5,
    price: 390,
    extraPhotoPrice: 90,
    selectionDeadline: '2026-09-10',
    status: 'ready',
    paymentStatus: 'client_reported',
    selectionLocked: true,
    archived: false,
    photos: demoPhotos.slice(0, 6).map(([filename, previewUrl], index) => ({
      id: `b${index + 1}`,
      filename,
      previewUrl,
      selected: index < 5,
      sortOrder: index
    }))
  }
];

export const demoBookings: Booking[] = [
  {
    id: 'b1',
    name: 'Karolina Nowak',
    email: 'karolina@example.com',
    phone: '+48 500 222 111',
    dogName: 'Milo',
    breed: 'Border Collie',
    age: '4',
    numberOfDogs: 1,
    packageId: 'standard',
    preferredDate: '2026-09-26',
    preferredTime: '16:00',
    location: 'Wrocław / outdoor',
    setting: 'outdoor',
    information: 'Golden-hour session if weather allows.',
    status: 'new',
    createdAt: '2026-09-14T12:00:00Z'
  }
];

export const demoReviews: Review[] = [
  { id: 'r1', clientName: 'Marta', dogName: 'Nala', stars: 5, text: 'Beautiful photographs and a very calm, patient session. Nala looked completely herself.', approved: true },
  { id: 'r2', clientName: 'Piotr', dogName: 'Bruno', stars: 5, text: 'The gallery selection was simple and the final photos were outstanding.', approved: true },
  { id: 'r3', clientName: 'Emily', dogName: 'Scout', stars: 5, text: 'Professional from start to finish. We especially loved the action shots.', approved: true }
];

export const demoSettings: StudioSettings = {
  blikPhone: '660 140 920',
  blikRecipient: 'Kyrylo Pochtar',
  watermarkText: 'PAWTRAIT STUDIO — PREVIEW',
  watermarkOpacity: 0.34,
  watermarkSize: 'medium',
  watermarkPosition: 'diagonal',
  repeatedWatermark: true,
  logoWatermark: false
};
